<template>
  <div class="content impact-content">
    <div class="header">
      <h1 class="h1">Donation Button Widget</h1>
    </div>
    <div class="row">
      <div class="col-sm-6">
        <textarea class="form-control" name="widget" cols="50" rows="7" :value="jsTemplate"></textarea>
      </div>
    </div>
  </div>
</template>

<script>
  import config from '../../../public/harness_config.json';
  import {mapState} from "vuex";

  export default {
    name: 'DonateButtonWidget',
    mounted() {
      this.attachJsExample();
    },
    metaInfo: {
      title: 'Donation Button Widget',
    },
    beforeDestroy() {
      this.deleteElement('.h-widget-wrap');
      this.deleteElement('.test-script-wrap');
    },
    methods: {
      deleteElement(selector) {
        if (document.querySelector(selector)) {
          const widgetWrap = document.querySelector(selector);
          widgetWrap.parentNode.removeChild(widgetWrap);
        }
      },
      attachJsExample() {
        this.deleteElement('.h-widget-wrap');
        this.deleteElement('.test-script-wrap');

        const widgetUrl = `${config.scheme}://widget.${config.url}/harness-widget.js`;

        const self = this;

        (function(url, callback) {
          // Adding the script tag to the head as suggested before
          const script = document.createElement('script');
          script.type = 'text/javascript';
          script.src = url;

          // Then bind the event to the callback function.
          // There are several events for cross browser compatibility.
          script.onreadystatechange = callback;
          script.onload = callback;

          const scriptWrap = document.createElement('div');
          scriptWrap.classList.add('test-script-wrap');
          scriptWrap.appendChild(script);

          document.body.appendChild(scriptWrap);

        })(widgetUrl, function() {
          window.HarnessWidget.init({charity_id: self.activeCharityId});
        });
      },
    },
    watch: {
      'activeCharityId'() {
        this.attachJsExample();
      },
    },
    computed: {
      ...mapState({
        activeCharityId: state => state.auth.activeCharityId,
      }),
      jsTemplate() {
        if (config.url === 'staging.harnessapp.com') {
          config.scheme = 'http';
        }

        const widgetUrl = `${config.scheme}://widget.${config.url}/harness-widget.js`;
        return '<script>\n!function(t,e){var a=document.head,n=document.createElement("script");n.type="text/javascript",n.src="' +
          widgetUrl +
          '",n.onreadystatechange=e,n.onload=e,a.appendChild(n)}(0,function(){window.HarnessWidget.init({charity_id:"' +
          this.activeCharityId + '"})});\n<' + '/script>';
      },
    },
    /*
      (function (url, callback) {
        // Adding the script tag to the head as suggested before
        var head = document.head;
        var script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = url;

        // Then bind the event to the callback function.
        // There are several events for cross browser compatibility.
        script.onreadystatechange = callback;
        script.onload = callback;

        // Fire the loading
        head.appendChild(script);
      })('//localhost:8090/harness-widget.js', function() {
        window.HarnessWidget.init({charity_id: 'clay'});
      });
    */
  };
</script>

